/**
 * The class to hold the descriptive values for Assessment data
 */
export class AssessmentDescriptiveValues {
  static MealPlanComplianceValues: {[key: string]: string} = {};
  static EnergyLevelValues: {[key: string]: string} = {};
  static StressLevelValues: {[key: string]: string} = {};
  static SleepQualityValues: {[key: string]: string} = {};

  static initialize() {
    // meal plan compliance
    AssessmentDescriptiveValues.MealPlanComplianceValues['1'] = $localize`:@@MealPlanComplianceValue1:Did not comply with meal plan.`;
    AssessmentDescriptiveValues.MealPlanComplianceValues['2'] = $localize`:@@MealPlanComplianceValue2:Partially complied with meal plan.`;
    AssessmentDescriptiveValues.MealPlanComplianceValues['3'] = $localize`:@@MealPlanComplianceValue3:Complied with about half of meal plan.`;
    AssessmentDescriptiveValues.MealPlanComplianceValues['4'] = $localize`:@@MealPlanComplianceValue4:Mostly complied with meal plan.`;
    AssessmentDescriptiveValues.MealPlanComplianceValues['5'] = $localize`:@@MealPlanComplianceValue5:Fully complied with meal plan.`;

    // energy level
    AssessmentDescriptiveValues.EnergyLevelValues['1'] = $localize`:@@EnergyLevelValue1:No energy.`;
    AssessmentDescriptiveValues.EnergyLevelValues['2'] = $localize`:@@EnergyLevelValue2:Lower energy than usual.`;
    AssessmentDescriptiveValues.EnergyLevelValues['3'] = $localize`:@@EnergyLevelValue3:Average energy level.`;
    AssessmentDescriptiveValues.EnergyLevelValues['4'] = $localize`:@@EnergyLevelValue4:More energy than usual.`;
    AssessmentDescriptiveValues.EnergyLevelValues['5'] = $localize`:@@EnergyLevelValue5:High-energy level.`;

    // stress level
    AssessmentDescriptiveValues.StressLevelValues['1'] = $localize`:@@StressLevelValue1:Very stressed.`;
    AssessmentDescriptiveValues.StressLevelValues['2'] = $localize`:@@StressLevelValue2:More stress than usual.`;
    AssessmentDescriptiveValues.StressLevelValues['3'] = $localize`:@@StressLevelValue3:About the same stress as usual.`;
    AssessmentDescriptiveValues.StressLevelValues['4'] = $localize`:@@StressLevelValue4:Lower stress than usual.`;
    AssessmentDescriptiveValues.StressLevelValues['5'] = $localize`:@@StressLevelValue5:No stress at all.`;

    // sleep quality
    AssessmentDescriptiveValues.SleepQualityValues['1'] = $localize`:@@SleepQualityValue1:Insomnia/No sleep at all.`;
    AssessmentDescriptiveValues.SleepQualityValues['2'] = $localize`:@@SleepQualityValue2:Lower quality of sleep than usual.`;
    AssessmentDescriptiveValues.SleepQualityValues['3'] = $localize`:@@SleepQualityValue3:About the same sleep quality as usual.`;
    AssessmentDescriptiveValues.SleepQualityValues['4'] = $localize`:@@SleepQualityValue4:Better quality of sleep than usual.`;
    AssessmentDescriptiveValues.SleepQualityValues['5'] = $localize`:@@SleepQualityValue5:Great quality/Restful sleep.`;

  }

}

AssessmentDescriptiveValues.initialize();
